/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from "styled-components";
import Colors from "constants/Colors";
import { Breakpoints } from "constants/Breakpoints";

export const Scrollbox = styled.div`
  overflow-y: auto;
  overflow-x: hidden;

  padding: 10px 20px 10px 0px;
  // max-height: 500px;

  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  background-color: ${Colors.WHITE};
  flex-direction: row;
  justify-content: space-evenly;

  @media (max-width: ${Breakpoints.lg}) {
    flex-wrap: wrap;
    padding-right: 10px;
    width: 100%;
  }
`;
